import { useQuery } from "react-query";
import { getStylesList } from "../api";
import { API_KEY_GET_NOTIFICATION_STYLES_OPTIONS } from "../constants";

export const useGetStyles = () => {
  return useQuery([API_KEY_GET_NOTIFICATION_STYLES_OPTIONS], () =>
    getStylesList()
  );
};
